<div class="advancedCFAccess__section">
  <h6 class="shareModalHeader">
    {{ 'related_point' | ppTranslate }}

    <i
      ppTooltip
      [ppOptions]="{ placement: 'right' }"
      class="fa fa-info-circle settingsSection__header-info"
      aria-hidden="true"
      [ppTitle]="'related_point_AAL_description' | ppTranslate"
      [ppMobileTooltip]="true"
    ></i>
  </h6>

  <pp-toggle
    [ppDisabled]="ppDisabled"
    ppId="toggleShowRelatedPoints"
    (ppAction)="correctProperty(EGoogleEventLabel.POINT_RELATIONSHIPS)"
    [ppChecked]="ppShare.advancedAccessLevels.pointsRelationships.permission.edit"
    [ppReverseLayout]="true"
    ppStyle="blue"
  >
    <span class="toggleInnerText">{{ 'add_relationship' | ppTranslate }}</span>
  </pp-toggle>
</div>
